@if(formGroup) {
  <form [formGroup]="formGroup" (ngSubmit)="save()">
    <dialog class="bm-modal" open (document:keydown.escape)="closeModal.emit()">
      <div class="bm-modal-box max-h-[80vh] overflow-y-auto">
        <ng-container *ngTemplateOutlet="tplFormContent"/>
        <div class="bm-modal-action">
          <button class="bm-btn bm-btn-secondary" type="button" (click)="closeModal.emit()">Abbrechen</button>
          <button class="bm-btn bm-btn-primary" [disabled]="!formGroup.valid">Speichern</button>          
        </div>
      </div>
    </dialog>
  </form>
}
<ng-template #tplFormContent>
  <h4 class="font-bold text-lg mb-4">Projekt-Techniker bearbeiten</h4>
  <fieldset class="bm-card bm-card-sm bm-fieldset px-0">
    <div class="bm-fieldset-content">
      <label class="bm-fieldset-label">PLZ-Gebiete</label>
      <input class="bm-input" formControlName="zip_area">
      <label class="bm-label">Einzelne PLZ oder Bereiche kommagetrennt, z.B. '10000,10200,20000-29999'</label>

      <label class="bm-fieldset-label">Bereitschaftszeit</label>
      <input class="bm-input" formControlName="standby_time">
      <label class="bm-label">Zeiten in denen der Techniker kontaktiert werden kann, Zeitbereiche kommagetrennt, z.B. '08:00-12:00,13:00-18:00'</label>

      <label class="bm-fieldset-label">Lagerplatz</label>
      <select class="bm-select" formControlName="bin_id">
        <option [value]="null">Keinen Platz zuordnen</option>
        @for (warehouse of warehouses; track $index) {
          <optgroup [label]="'Lager: ' + warehouse.label">
            @for (bin of (warehouse.bins || []); track bin.id) {
              <option [value]="bin.id">Platz: {{bin.name}}</option>
            }
          </optgroup>
        }
      </select>
    </div>
  </fieldset>
